<div class="flex-col gap-0 flex pb-5">
  <div *ngFor="let i of indices" class="checkbox">
    <mat-checkbox [checked]="getValue(selectedIndices, i)"
                  id="checkbox_{{i}}"
                  (change)="changeSelected(i)">
      {{indexLabels[i]}}
    </mat-checkbox>
  </div>
</div>
